import type { PageItem } from './api/page';

export const defaultTextElementStyle = {
  titleA: {
    fontFamily: 'Nanum Gothic',
    fontSize: 24,
  },
  titleB: {
    fontFamily: 'Noto Sans KR',
    fontSize: 24,
  },
  subjectA: {
    fontFamily: 'Nanum Gothic',
    fontSize: 14,
  },
  subjectB: {
    fontFamily: 'Noto Sans KR',
    fontSize: 14,
  },
};

export const fontList = [
  { title: '나눔고딕', fontFamily: 'Nanum Gothic'},
  { title: '나눔고딕 Bold', fontFamily: 'Nanum Gothic Bold'},
  { title: '나눔고딕 ExtraBold', fontFamily: 'Nanum Gothic ExtraBold'},
  { title: '나눔명조', fontFamily: 'Nanum Myeongjo'},
  { title: '나눔명조 Bold', fontFamily: 'Nanum Myeongjo Bold'},
  { title: '나눔명조 ExtraBold', fontFamily: 'Nanum Myeongjo ExtraBold'},
  { title: '나눔스퀘어 Light', fontFamily: 'NanumSquare Light'},
  { title: '나눔스퀘어', fontFamily: 'NanumSquare'},
  { title: '나눔스퀘어 Bold', fontFamily: 'NanumSquare Bold'},
  { title: '나눔스퀘어 ExtraBold', fontFamily: 'NanumSquare ExtraBold'},
  { title: '도현', fontFamily: 'Do Hyeon'},
  { title: '싱글데이', fontFamily: 'Single Day'},
  { title: '썬플라워 Light', fontFamily: 'Sunflower Light'},
  { title: '썬플라워', fontFamily: 'Sunflower'},
  { title: '썬플라워 Bold', fontFamily: 'Sunflower Bold'},
  { title: '연성', fontFamily: 'Yeon Sung'},
  { title: 'Abril Fatface', fontFamily: 'Abril Fatface'},
  { title: 'Barlow Condensed Medium', fontFamily: 'Barlow Condensed Medium'},
  { title: 'Barlow Condensed Bold', fontFamily: 'Barlow Condensed Bold'},
  { title: 'Cormorant Garamond Bold', fontFamily: 'Cormorant Garamond Bold'},
  { title: 'Josefin Sans Light', fontFamily: 'Josefin Sans Light'},
  { title: 'Josefin Sans', fontFamily: 'Josefin Sans'},
  { title: 'Josefin Sans SemiBold', fontFamily: 'Josefin Sans SemiBold'},
  { title: 'Josefin Sans Bold', fontFamily: 'Josefin Sans Bold'},
  { title: 'Mansalva', fontFamily: 'Mansalva'},
  { title: 'Montserrat Light', fontFamily: 'Montserrat Light'},
  { title: 'Montserrat', fontFamily: 'Montserrat'},
  { title: 'Montserrat Medium', fontFamily: 'Montserrat Medium'},
  { title: 'Montserrat Bold', fontFamily: 'Montserrat Bold'},
  { title: 'Montserrat Black', fontFamily: 'Montserrat Black'},
  { title: 'Noto Sans KR Light', fontFamily: 'Noto Sans KR Light'},
  { title: 'Noto Sans KR', fontFamily: 'Noto Sans KR'},
  { title: 'Noto Sans KR Medium', fontFamily: 'Noto Sans KR Medium'},
  { title: 'Noto Sans KR Bold', fontFamily: 'Noto Sans KR Bold'},
  { title: 'Noto Serif KR Light', fontFamily: 'Noto Serif KR Light'},
  { title: 'Noto Serif KR', fontFamily: 'Noto Serif KR'},
  { title: 'Noto Serif KR Medium', fontFamily: 'Noto Serif KR Medium'},
  { title: 'Noto Serif KR SemiBold', fontFamily: 'Noto Serif KR SemiBold'},
  { title: 'Noto Serif KR Bold', fontFamily: 'Noto Serif KR Bold'},
  { title: 'Nothing You Could Do', fontFamily: 'Nothing You Could Do'},
  { title: 'Play', fontFamily: 'Play'},
  { title: 'Play Bold', fontFamily: 'Play Bold'},
  { title: 'Playfair Display', fontFamily: 'Playfair Display'},
  { title: 'Playfair Display Bold', fontFamily: 'Playfair Display Bold'},
  { title: 'Playfair Display Black', fontFamily: 'Playfair Display Black'},
  { title: 'Poppins ExtraLight', fontFamily: 'Poppins ExtraLight'},
  { title: 'Poppins Light', fontFamily: 'Poppins Light'},
  { title: 'Poppins', fontFamily: 'Poppins'},
  { title: 'Poppins Medium', fontFamily: 'Poppins Medium'},
  { title: 'Poppins Bold', fontFamily: 'Poppins Bold'},
  { title: 'Poppins Black', fontFamily: 'Poppins Black'},
  { title: 'Roboto Light', fontFamily: 'Roboto Light'},
  { title: 'Roboto', fontFamily: 'Roboto'},
  { title: 'Roboto Medium', fontFamily: 'Roboto Medium'},
  { title: 'Roboto Bold', fontFamily: 'Roboto Bold'},
  { title: 'Roboto Black', fontFamily: 'Roboto Black'},
  { title: 'Roboto Condensed Light', fontFamily: 'Roboto Condensed Light'},
  { title: 'Roboto Condensed', fontFamily: 'Roboto Condensed'},
  { title: 'Roboto Condensed Bold', fontFamily: 'Roboto Condensed Bold'},
  { title: 'Tenor Sans', fontFamily: 'Tenor Sans'},
];

export const defaultPageContent = (): Omit<PageItem, 'title' | 'url'> => ({
  background: {
    type: 'color',
    value: '#fff',
  },
  sectionIds: [],
  elements: {},
});
